





import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {DisplayEnum} from '@/types/enum';

interface NewDisplayEnum extends DisplayEnum {
  text: string;
}

@Component
export default class ProductListSearchMenu extends Vue {
  @Prop({
    required: true,
    default: [],
    type: Array,
  })
  private readonly data!: {[propName: string]: any}[];

  @Prop({
    required: false,
    default: '',
    type: String,
  })
  private readonly emptyText?: string;

  @Watch('data', {immediate: true, deep: true})
  onDataChange() {
    this.$nextTick(() => {
      this.dataHandle();
    });
  }

  @Prop({
    required: true,
    default: '',
    type: String,
  })
  private readonly inputVal!: '';

  @Watch('inputVal', {immediate: true, deep: true})
  onInputValChange() {
    this.$nextTick(() => {
      this.dataHandle();
    });
  }

  @Prop({
    required: true,
    default: '',
    type: String,
  })
  private readonly labelName!: string;

  @Prop({
    required: true,
    default: '',
    type: String,
  })
  private readonly valueName!: string;

  @Prop({
    required: false,
    default: false,
    type: Boolean,
  })
  private readonly isAdminSearchMenu!: boolean;

  @Prop({required: true, default: false, type: Boolean})
  private readonly show!: boolean;

  private selectedIdx = -1;

  private resultList: NewDisplayEnum[] = [];

  private dataHandle(): void {
    const label = this.emptyText || (this.$t('PRODUCT_PRODUCTLIST_NO_RESULTS_WERE_FOUND_FOR_YOUR_SEARCH') as string);
    if (this.inputVal.length) {
      const regexp = new RegExp(this.inputVal.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), 'gi');
      const result = this.data.filter(item => item[this.labelName].match(regexp));
      if (result.length) {
        this.resultList = result.map(list => {
          const labelName = this.isAdminSearchMenu ? `${list[this.labelName]}(${list.id})` : list[this.labelName];
          return {text: list[this.labelName], value: list[this.valueName], label: labelName.replace(regexp, '<span>$&</span>')};
        });
      } else {
        this.resultList = [{value: '0', label, text: ''}];
      }
    } else {
      this.resultList = [{value: '0', label, text: ''}];
    }
  }

  private itemClick(item: any) {
    if (item.value !== '0') {
      this.$emit('selected', this.valueName, item);
    }
  }

  private pressDown() {
    if (this.selectedIdx < this.resultList.length - 1) {
      this.selectedIdx++;
    } else {
      this.selectedIdx = 0;
    }
  }

  private pressUp() {
    if (this.selectedIdx === 0 || this.selectedIdx === -1) {
      this.selectedIdx = this.resultList.length - 1;
    } else {
      this.selectedIdx--;
    }
  }

  private pressEnter() {
    if (this.selectedIdx === -1) {
      return;
    }

    const result = this.resultList[this.selectedIdx];
    if (result.value !== '0') {
      this.$emit('selected', this.valueName, result);
      this.selectedIdx = -1;
    }
  }
}
